import React, { useState, useEffect } from "react";
import "./CourseSyllabus.css";
import Popupboxx from "../Popupbox/Popupbox";
import AOS from "aos";
import "aos/dist/aos.css";

const modules = [
  {
    title: "Introduction to Cloud Computing & Microsoft Azure",
    points: [
      "What is Cloud Computing and its advantages",
      "Overview of Microsoft Azure cloud platform",
      "Cloud service models: IaaS, PaaS, SaaS",
      "Azure global infrastructure (Regions and Availability Zones)",
    ],
  },
  {
    title: "Azure Core Services",
    points: [
      "Introduction to Azure Virtual Machines",
      "Azure Storage services (Blob, File, Queue, Table)",
      "Azure App Services overview",
      "Understanding Azure pricing and subscriptions",
    ],
  },
  {
    title: "Azure Networking",
    points: [
      "Azure Virtual Network (VNet) fundamentals",
      "Subnets, Network Security Groups (NSG)",
      "Azure Load Balancer and Application Gateway",
      "VPN Gateway and ExpressRoute basics",
    ],
  },
  {
    title: "Azure Identity & Security",
    points: [
      "Azure Active Directory (Azure AD) basics",
      "Users, groups, and role-based access control (RBAC)",
      "Multi-Factor Authentication (MFA)",
      "Azure Key Vault for secrets management",
    ],
  },
  {
    title: "Azure Databases & Storage",
    points: [
      "Azure SQL Database fundamentals",
      "Cosmos DB (NoSQL database) overview",
      "Data redundancy and replication options",
      "Backup and recovery in Azure",
    ],
  },
  {
    title: "Azure Compute & Serverless",
    points: [
      "Azure Virtual Machines management",
      "Azure Functions (Serverless computing)",
      "Azure Kubernetes Service (AKS) basics",
      "App Service deployment strategies",
    ],
  },
  {
    title: "Monitoring & Management",
    points: [
      "Azure Monitor overview",
      "Log Analytics and Application Insights",
      "Azure Security Center basics",
      "Setting alerts and dashboards",
    ],
  },
  {
    title: "DevOps on Azure",
    points: [
      "Introduction to Azure DevOps services",
      "CI/CD pipelines using Azure Pipelines",
      "Git integration with Azure Repos",
      "Infrastructure as Code using ARM Templates & Terraform",
    ],
  },
  {
    title: "Real-Time Projects & Deployment",
    points: [
      "Hosting web applications on Azure App Service",
      "Deploying APIs using Azure Functions",
      "Static website hosting on Azure Storage",
      "End-to-end cloud project implementation",
    ],
  },
];
function CourseSyllabus() {
  const [activeModule, setActiveModule] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  // Detect screen size
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize(); // check on load
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

   useEffect(() => {
      AOS.init({ duration: 800, once: true });
    }, []);

  return (
    <>
    <section className="syllabus-section">
      <div className="container">
        <div className="headlines-for-all">
          <h4   data-aos="fade-up">
            <span>Course </span> Syllabus
          </h4>
          <p  data-aos="fade-up">
            Explore our comprehensive Azure syllabus — built for
            real-world projects, hands-on learning, and 100% job readiness.
          </p>
        </div>


        {/* ---------- Desktop Tabs ---------- */}
        {!isMobile && (
          <>
            <div className="custom-btn-group "   data-aos="fade-up">
              {modules.map((m, index) => (
                <button
                  key={index}
                  className={`custom-btn ${activeModule === index ? "active" : ""
                    }`}
                  onClick={() => setActiveModule(index)}
                >
                  Module {index + 1}
                </button>
              ))}
            </div>

            <div className="custom-module-container"   data-aos="fade-up">
              <div className="custom-module-box active">
                <h4>{modules[activeModule].title}</h4>
                <ul className="ul-list-module">
                  {modules[activeModule].points.map((p, i) => (
                    <li key={i}>{p}</li>
                  ))}
                </ul>
              </div>
            </div>
          </>
        )}

        {/* ---------- Mobile Accordion (FAQ Style) ---------- */}
        {isMobile && (
          <div className="faq-container-course"   data-aos="fade-up">
            {modules.map((m, index) => (
              <div
                key={index}
                className={`faq-item-course ${activeModule === index ? "open" : ""
                  }`}
              >
                <button
                  className="faq-question-course"
                  onClick={() =>
                    setActiveModule(activeModule === index ? null : index)
                  }
                >
                  {m.title}
                  <span className="faq-icon-course">
                    {activeModule === index ? "−" : "+"}
                  </span>
                </button>

                <div
                  className="faq-answer-course"
                  style={{
                    maxHeight: activeModule === index ? "400px" : "0px",
                  }}
                >
                  <ul>
                    {m.points.map((p, i) => (
                      <li key={i}>{p}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="btn-center"   data-aos="fade-up">
          <button className="download-btn" onClick={() => setIsPopupOpen(true)}>Download Syllabus</button>
        </div>
      </div>
    </section>

  
       <Popupboxx
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
      />
      </>
  );
}

export default CourseSyllabus;
